import mapValues from 'lodash/mapValues';

export default function removeTrackPoint(pointLocalId: string, track: Track): Track | undefined {
    if (!track.isGeometryLoaded) return undefined;

    const removedPoint = track.points[pointLocalId];
    if (removedPoint.properties.archived || removedPoint.properties.deleted) {
        return track;
    }

    return {
        ...track,
        points: mapValues(track.points, (point: TrackPoint) => {
            if (point.properties.archived || point.properties.deleted) {
                return point;
            } else if (point.properties.localId === pointLocalId) {
                return {
                    ...point,
                    properties: {
                        ...point.properties,
                        archived: true,
                        isGeometryModified: true,
                    },
                };
            } else if (point.properties.order > removedPoint.properties.order) {
                return {
                    ...point,
                    properties: {
                        ...point.properties,
                        order: point.properties.order - 1,
                    },
                };
            } else {
                return point;
            }
        }),
    };
}
